/**
 * @description Предотвратить покидание страницы без подтверждения.
 */
export default {
  created() {
    window.addEventListener('beforeunload', this.onBeforeUnload, { capture: true });
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload, { capture: true });
  },
  beforeRouteLeave(to, from, next) {
    if (this.needPreventLeave) {
      this.actionAfterClosingDialogLeaveConfirm = next;
      this.isShownDialogLeaveConfirm = true;
    } else {
      next();
    }
  },
  computed: {
    /**
     * @description Предотвращать уход со страницы.
     * @type {boolean}
     */
    needPreventLeave: () => false,
  },
  data() {
    return {
      /**
       * @description Показывать диалог подтверждения ухода.
       * @type {boolean}
       */
      isShownDialogLeaveConfirm: false,
      /**
       * @description Действие после закрытия диалога подтверждения ухода.
       */
      actionAfterClosingDialogLeaveConfirm: () => {},
    };
  },
  methods: {
    onBeforeUnload(event) {
      if (this.needPreventLeave) {
        event.preventDefault();
        const message = 'Остались не сохраненные данные';
        return message;
      }
      return false;
    },
    /**
     * @description Покинуть без сохранения.
     * @returns {void}
     */
    leaveWithoutSave() {
      this.isShownDialogLeaveConfirm = false;
      this.actionAfterClosingDialogLeaveConfirm();
    },
  },
};
